import {
    TOP_BAR_LOAD,
    TOP_BAR_LOAD_FAIL,
    TOP_BAR_LOAD_SUCCESS
} from './constants';

//
export const TopBarLoadReducer = (state = {}, action) => {
    let ret = {
        ...state,
        idKey: Math.random()
    }
    const data = action.payload;
    switch (action.type) {
        case TOP_BAR_LOAD:
            ret.loading = true;
            ret.error = null;
            ret.loadSuccess = null;
            ret.loadDatas = null;
            break;
        case TOP_BAR_LOAD_SUCCESS:
            ret.loading = false;
            ret.loadSuccess = true;
            ret.loadDatas = data.loadDatas;
            break;
        case TOP_BAR_LOAD_FAIL:
            ret.loading = false;
            ret.loadSuccess = false;
            ret.error = data;
            break;
        default:
            return {...state};
    }
    return ret;
}
